/**
 * Resizable panel setup - shared between editor and viewer
 */

/**
 * Setup resizable panel divider
 * @param {Object} options - Configuration options
 * @param {Function} options.onResize - Callback function called after resize completes
 * @param {string} options.storageKey - Optional localStorage key to persist panel width
 */
export function setupResizer({ onResize, storageKey = null }) {
  const resizer = document.getElementById('resizer');
  const leftPanel = document.getElementById('left-column');
  const main = document.querySelector('main');

  if (!resizer || !leftPanel || !main) {
    console.warn('Resizer elements not found');
    return;
  }

  // Restore saved width if storage key provided
  if (storageKey) {
    const savedWidth = localStorage.getItem(storageKey);
    if (savedWidth) {
      main.style.setProperty('--panel-width', savedWidth + 'px');
    }
  }

  let isResizing = false;
  let startX = 0;
  let startWidth = 0;

  resizer.addEventListener('mousedown', (e) => {
    isResizing = true;
    startX = e.clientX;
    startWidth = leftPanel.offsetWidth;
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!isResizing) return;

    const delta = e.clientX - startX;
    const viewportWidth = window.innerWidth;

    // Min 20% of viewport, Max 60% of viewport
    const minWidth = Math.max(250, viewportWidth * 0.2); // At least 250px or 20% of viewport
    const maxWidth = viewportWidth * 0.6; // Max 60% of viewport

    const newWidth = Math.max(minWidth, Math.min(maxWidth, startWidth + delta));

    main.style.setProperty('--panel-width', newWidth + 'px');
  });

  document.addEventListener('mouseup', () => {
    if (isResizing) {
      isResizing = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';

      // Save to localStorage if storage key provided
      if (storageKey) {
        const currentWidth = leftPanel.offsetWidth;
        localStorage.setItem(storageKey, currentWidth);
      }

      // Trigger callback after resize
      if (onResize) {
        setTimeout(onResize, 50);
      }
    }
  });
}
